import { IFormAllowSubmit } from "@ngt/forms-core";
import { IForm, IFormValidationError, ValidationErrorType } from "@ngt/opms";
import { useCallback } from "react";


const useEConsentFormAllowSubmit =  <TData extends IForm = IForm>(allowSubmit: IFormAllowSubmit<TData, IFormValidationError> | null | undefined) => {
    const allowSubmitToUse: IFormAllowSubmit<TData, IFormValidationError> = useCallback(async (formState, formActions) => {
        if (allowSubmit)
        {
            return await allowSubmit(formState, formActions);
        }

        const { errors } = formState;

        if (!errors) {
            return true;
        }

        const hasCriticalError = !Object.keys(errors).some(key => errors[key] && errors[key].some(e => (e.type ?? ValidationErrorType.Normal) >= ValidationErrorType.Normal));
        return hasCriticalError;
    }, [allowSubmit]);

    return allowSubmitToUse;
};

export default useEConsentFormAllowSubmit;